<template>
  <div class="modal-overlay">
    <div class="mmodal-content" style="max-width: 90vw">
      <div class="modal-header">
        <h5 class="modal-title">Create Hospital Visit</h5>
        <button type="button" class="close" @click="closeModal">&times;</button>
      </div>
      <div class="modal-body">
        <form style="border-bottom: 3px solid black" v-if="!loading">
          <!-- Patient Type Selection -->
          <div
            class="row mb-3"
            style="border-bottom: 2px solid #f0f0f0; padding-bottom: 15px"
          >
            <div class="col-md-12">
              <h6>Patient Type</h6>
              <div class="form-check form-check-inline">
                <input
                  v-model="patientType"
                  class="form-check-input"
                  type="radio"
                  name="patientType"
                  value="main"
                  @change="handlePatientTypeChange"
                />
                <label class="form-check-label" for="mainPatient"
                  >Main Patient (Adult)</label
                >
              </div>
              <div class="form-check form-check-inline">
                <input
                  v-model="patientType"
                  class="form-check-input"
                  type="radio"
                  name="patientType"
                  value="dependent"
                  @change="handlePatientTypeChange"
                />
                <label class="form-check-label" for="dependentPatient"
                  >Dependent (Minor/Child)</label
                >
              </div>
            </div>
          </div>

          <!-- PATIENT DETAILS SECTION -->
          <div
            class="row mb-4"
            style="border-bottom: 2px solid #007bff; padding-bottom: 20px"
          >
            <div class="col-md-12">
              <h6>Patient Details</h6>
            </div>

            <!-- Main Patient Details -->
            <div v-if="patientType === 'main'" class="col-md-12">
              <div class="row">
                <div class="form-group col-md-6">
                  <label for="patientName">Patient Name</label>
                  <PatientInput @patientoption-check="get_patient" />
                  <div v-if="errors.patient_name" class="text-danger small">
                    {{ errors.patient_name }}
                  </div>
                </div>
                <div class="form-group col-md-3">
                  <div class="form-check form-check-inline">
                    <input
                      v-model="selecteddobOption"
                      class="form-check-input"
                      type="radio"
                      name="dob_age"
                      value="dob"
                      checked
                    />
                    <label class="form-check-label" for="dob">DOB</label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input
                      v-model="selecteddobOption"
                      class="form-check-input"
                      type="radio"
                      name="dob_age"
                      value="age"
                    />
                    <label class="form-check-label" for="age">Age</label>
                  </div>
                  <input
                    v-if="selecteddobOption === 'dob'"
                    @change="change_input"
                    type="date"
                    name="dob"
                    class="form-control"
                    :class="{ 'is-invalid': errors.dob }"
                    :value="dob"
                    placeholder="Date of Birth"
                  />
                  <input
                    v-if="selecteddobOption === 'age'"
                    @keyup="change_input"
                    type="number"
                    name="age"
                    class="form-control"
                    :class="{ 'is-invalid': errors.age }"
                    :value="age"
                    placeholder="Age"
                  />
                  <div v-if="errors.dob" class="text-danger small">
                    {{ errors.dob }}
                  </div>
                  <div v-if="errors.age" class="text-danger small">
                    {{ errors.age }}
                  </div>
                </div>
                <div class="form-group col-md-3">
                  <label for="gender">Gender</label>
                  <select
                    @change="change_input"
                    class="form-control"
                    :class="{ 'is-invalid': errors.gender }"
                    name="gender"
                  >
                    <option value="">Choose...</option>
                    <option
                      v-for="gen in genders"
                      :value="gen.id"
                      :key="gen.id"
                      :selected="gen.id == gender"
                    >
                      {{ gen.name }}
                    </option>
                  </select>
                  <div v-if="errors.gender" class="text-danger small">
                    {{ errors.gender }}
                  </div>
                </div>
              </div>

              <div class="row mt-3">
                <div class="form-group col-md-4">
                  <label for="residence">Residence</label>
                  <input
                    type="text"
                    name="residence"
                    @change="change_input"
                    class="form-control"
                    :value="residence"
                    placeholder="Residence"
                  />
                </div>
                <div class="form-group col-md-3">
                  <label for="passport">ID/Passport No.</label>
                  <input
                    type="text"
                    name="passport"
                    @change="change_input"
                    class="form-control"
                    :class="{ 'is-invalid': errors.passport }"
                    :value="passport"
                    placeholder="ID/Passport"
                  />
                  <div v-if="errors.passport" class="text-danger small">
                    {{ errors.passport }}
                  </div>
                </div>
                <div class="form-group col-md-3">
                  <label for="phone">Phone No.</label>
                  <input
                    type="number"
                    name="phone"
                    @change="change_input"
                    class="form-control"
                    :value="phone"
                    placeholder="Phone"
                  />
                </div>
                <div class="form-group col-md-2">
                  <label for="opd">OPD</label>
                  <input
                    disabled
                    type="text"
                    name="opd"
                    class="form-control"
                    :value="opd"
                    placeholder="OPD"
                  />
                </div>
              </div>

              <div class="row mt-3">
                <div class="form-group col-md-6">
                  <label for="email">Email</label>
                  <input
                    type="email"
                    name="email"
                    @change="validateEmailField"
                    class="form-control"
                    :class="{ 'is-invalid': errors.email }"
                    :value="email"
                    placeholder="Email"
                  />
                  <div v-if="errors.email" class="text-danger small">
                    {{ errors.email }}
                  </div>
                </div>
              </div>
            </div>

            <!-- Dependent Patient Details -->
            <div v-if="patientType === 'dependent'" class="col-md-12">
              <div class="row">
                <div class="form-group col-md-6">
                  <label for="patientName">Dependent Name</label>
                  <PatientInput
                    :PassedPatientName="patient_name"
                    @patientoption-check="get_patient"
                  />
                  <div v-if="errors.patient_name" class="text-danger small">
                    {{ errors.patient_name }}
                  </div>
                </div>
                <div class="form-group col-md-3">
                  <div class="form-check form-check-inline">
                    <input
                      v-model="selecteddobOption"
                      class="form-check-input"
                      type="radio"
                      name="dob_age"
                      value="dob"
                      checked
                    />
                    <label class="form-check-label" for="dob">DOB</label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input
                      v-model="selecteddobOption"
                      class="form-check-input"
                      type="radio"
                      name="dob_age"
                      value="age"
                    />
                    <label class="form-check-label" for="age">Age</label>
                  </div>
                  <input
                    v-if="selecteddobOption === 'dob'"
                    @change="change_input"
                    type="date"
                    name="dob"
                    class="form-control"
                    :class="{ 'is-invalid': errors.dob }"
                    :value="dob"
                    placeholder="Date of Birth"
                  />
                  <input
                    v-if="selecteddobOption === 'age'"
                    @keyup="change_input"
                    type="number"
                    name="age"
                    class="form-control"
                    :class="{ 'is-invalid': errors.age }"
                    :value="age"
                    placeholder="Age"
                  />
                  <div v-if="errors.dob" class="text-danger small">
                    {{ errors.dob }}
                  </div>
                  <div v-if="errors.age" class="text-danger small">
                    {{ errors.age }}
                  </div>
                </div>
                <div class="form-group col-md-3">
                  <label for="gender">Gender</label>
                  <select
                    @change="change_input"
                    class="form-control"
                    :class="{ 'is-invalid': errors.gender }"
                    name="gender"
                  >
                    <option value="">Choose...</option>
                    <option
                      v-for="gen in genders"
                      :value="gen.id"
                      :key="gen.id"
                      :selected="gen.id == gender"
                    >
                      {{ gen.name }}
                    </option>
                  </select>
                  <div v-if="errors.gender" class="text-danger small">
                    {{ errors.gender }}
                  </div>
                </div>
              </div>

              <div class="row mt-3">
                <div class="form-group col-md-2">
                  <label for="opd">OPD</label>
                  <input
                    disabled
                    type="text"
                    name="opd"
                    class="form-control"
                    :value="opd"
                    placeholder="OPD"
                  />
                </div>
              </div>
            </div>
          </div>

          <!-- VISIT DETAILS SECTION (Shows first for Main Patient) -->
          <div
            v-if="patientType === 'main'"
            class="row mb-4"
            style="border-bottom: 2px solid #28a745; padding-bottom: 20px"
          >
            <div class="col-md-12">
              <h6 style="color: #28a745">Visit Details</h6>
            </div>

            <div class="form-group col-md-4">
              <label for="clinic_id">Clinic / Speciality</label>
              <select @change="change_input" class="form-control" name="clinic">
                <option disabled value="">Choose...</option>
                <option
                  :selected="clinic.id == 1"
                  v-for="clinic in clinics"
                  :value="clinic.id"
                  :key="clinic.id"
                >
                  {{ clinic.clinic_name }}
                </option>
              </select>
            </div>

            <!-- <div class="form-group col-md-4">
              <label for="complaints">Complaints / Symptom / Illness</label>
              <textarea
                name="complaints"
                @change="change_input"
                class="form-control"
                :value="complaints"
                placeholder="Complaints"
                rows="2"
              ></textarea>
            </div> -->

            <div class="form-group col-md-4">
              <div class="form-check form-check-inline">
                <input
                  v-model="emergency"
                  class="form-check-input"
                  type="radio"
                  name="emergency"
                  value="0"
                  checked
                />
                <label class="form-check-label" for="normal">Normal</label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  v-model="emergency"
                  class="form-check-input"
                  type="radio"
                  name="emergency"
                  value="1"
                />
                <label class="form-check-label" for="emergency"
                  >Emergency</label
                >
              </div>
            </div>

            <div class="form-group col-md-4">
              <label for="paymentMode">Mode of Payment</label>
              <select
                @change="change_input"
                class="form-control"
                :class="{ 'is-invalid': errors.paymentMode }"
                name="paymentMode"
              >
                <option value="">Choose...</option>
                <option value="1">Cash</option>
                <option value="2">Invoice</option>
              </select>
              <div v-if="errors.paymentMode" class="text-danger small">
                {{ errors.paymentMode }}
              </div>
            </div>

            <div class="form-group col-md-4">
              <label for="department">Department to Send Patient To</label>
              <select
                @change="change_input"
                class="form-control"
                name="department"
              >
                <option disabled value="">Choose...</option>
                <option
                  :selected="department.id == 4"
                  v-for="department in departments"
                  :value="department.id"
                  :key="department.id"
                >
                  {{
                    department.department_name +
                    " - " +
                    department.department_description +
                    "(" +
                    department.department_code_id +
                    ")"
                  }}
                </option>
              </select>
            </div>

            <!-- Consultation Charges -->
            <div class="form-group col-md-4">
              <div class="form-check form-check-inline">
                <input
                  v-model="consultation_charge"
                  class="form-check-input"
                  type="radio"
                  name="charge_id"
                  value="1"
                  @change="handlechargeRadioChange"
                />
                <label class="form-check-label" for="applyCharge"
                  >Apply Consultation Charge</label
                >
              </div>
              <div class="form-check form-check-inline">
                <input
                  v-model="consultation_charge"
                  class="form-check-input"
                  type="radio"
                  name="charge_id"
                  value="0"
                  @change="handlechargeRadioChange"
                />
                <label class="form-check-label" for="noCharge">No Charge</label>
              </div>
            </div>

            <div v-if="consultation_charge == 1" class="form-group col-md-4">
              <label for="charge_id">Consultation Charge</label>
              <select
                @change="change_input"
                class="form-control"
                name="charge_id"
              >
                <option
                  v-for="consultation_charge in consultation_charges_arr"
                  :value="consultation_charge.id"
                  :key="consultation_charge.id"
                >
                  {{ consultation_charge.service_name }}
                </option>
              </select>
            </div>
          </div>

          <!-- NEXT OF KIN SECTION -->
          <div
            class="row mb-4"
            :style="
              patientType === 'dependent'
                ? 'border: 2px solid #ffc107; border-radius: 5px; padding: 20px; margin-bottom: 20px;'
                : 'border: 2px solid #17a2b8; border-radius: 5px; padding: 20px; margin-bottom: 20px;'
            "
          >
            <div class="col-md-12">
              <h6
                :style="
                  patientType === 'dependent'
                    ? 'color: #ffc107;'
                    : 'color: #17a2b8;'
                "
              >
                Next of Kin Details
                {{ patientType === "dependent" ? "(Parent/Guardian)" : "" }}
              </h6>
              <small v-if="patientType === 'dependent'" class="text-muted">
                For dependent patients, next of kin must be a parent or guardian
              </small>
            </div>

            <div class="form-group col-md-3">
              <label for="next_of_kin_name">Next of Kin Name</label>
              <input
                type="text"
                name="next_of_kin_name"
                @change="change_input"
                class="form-control"
                :class="{ 'is-invalid': errors.next_of_kin_name }"
                :value="next_of_kin_name"
                placeholder="Full Name"
                :required="patientType === 'dependent'"
              />
              <div v-if="errors.next_of_kin_name" class="text-danger small">
                {{ errors.next_of_kin_name }}
              </div>
            </div>
            <div class="form-group col-md-3">
              <label for="next_of_kin_relationship">Relationship</label>
              <select
                @change="change_input"
                class="form-control"
                :class="{ 'is-invalid': errors.next_of_kin_relationship }"
                name="next_of_kin_relationship"
                :required="patientType === 'dependent'"
              >
                <option value="">Choose Relationship...</option>
                <option
                  value="parent"
                  :selected="next_of_kin_relationship == 'parent'"
                >
                  Parent
                </option>
                <option
                  value="spouse"
                  :selected="next_of_kin_relationship === 'spouse'"
                >
                  Spouse
                </option>
                <option
                  value="guardian"
                  :selected="next_of_kin_relationship == 'guardian'"
                >
                  Guardian
                </option>
                <option
                  value="sibling"
                  :selected="next_of_kin_relationship == 'sibling'"
                >
                  Sibling
                </option>
                <option
                  value="child"
                  :selected="next_of_kin_relationship == 'child'"
                >
                  Child
                </option>
                <option
                  value="other_relative"
                  :selected="next_of_kin_relationship == 'other_relative'"
                >
                  Other Relative
                </option>
                <option
                  value="friend"
                  :selected="next_of_kin_relationship == 'friend'"
                >
                  Friend
                </option>
                <option
                  value="other"
                  :selected="next_of_kin_relationship == 'other'"
                >
                  Other
                </option>
              </select>
              <div
                v-if="errors.next_of_kin_relationship"
                class="text-danger small"
              >
                {{ errors.next_of_kin_relationship }}
              </div>
            </div>
            <div class="form-group col-md-3">
              <label for="next_of_kin_phone">Phone Number</label>
              <input
                type="number"
                name="next_of_kin_phone"
                @change="change_input"
                class="form-control"
                :value="next_of_kin_phone"
                placeholder="Phone Number"
                :required="patientType === 'dependent'"
              />
            </div>
            <div v-if="patientType != 'main'" class="form-group col-md-2">
              <label for="next_of_kin_id">ID Number</label>
              <input
                type="text"
                name="next_of_kin_id"
                @change="change_input"
                class="form-control"
                :value="next_of_kin_id"
                placeholder="ID Number"
                :required="patientType === 'dependent'"
              />
            </div>

            <!-- Next of Kin Address and Email - Now inside the same section -->
            <div class="form-group col-md-3 mt-0">
              <label for="next_of_kin_address">Address</label>
              <input
                type="text"
                name="next_of_kin_address"
                @change="change_input"
                class="form-control"
                :value="next_of_kin_address"
                placeholder="Physical Address"
              />
            </div>
            <div v-if="patientType != 'main'" class="form-group col-md-6 mt-3">
              <label for="next_of_kin_email">Email Address (Optional)</label>
              <input
                type="email"
                name="next_of_kin_email"
                @change="validateEmailField"
                class="form-control"
                :class="{ 'is-invalid': errors.next_of_kin_email }"
                :value="next_of_kin_email"
                placeholder="Email Address"
              />
              <div v-if="errors.next_of_kin_email" class="text-danger small">
                {{ errors.next_of_kin_email }}
              </div>
            </div>
          </div>

          <!-- VISIT DETAILS SECTION (Shows after Next of Kin for Dependent Patient) -->
          <div
            v-if="patientType === 'dependent'"
            class="row mb-4"
            style="border: 2px solid #28a745; border-radius: 5px; padding: 20px"
          >
            <div class="col-md-12">
              <h6 style="color: #28a745">Visit Details</h6>
            </div>

            <div class="form-group col-md-4">
              <label for="clinic_id">Clinic / Speciality</label>
              <select @change="change_input" class="form-control" name="clinic">
                <option disabled value="">Choose...</option>
                <option
                  :selected="clinic.id == 1"
                  v-for="clinic in clinics"
                  :value="clinic.id"
                  :key="clinic.id"
                >
                  {{ clinic.clinic_name }}
                </option>
              </select>
            </div>

            <!-- <div class="form-group col-md-4">
              <label for="complaints">Complaints / Symptom / Illness</label>
              <textarea
                name="complaints"
                @change="change_input"
                class="form-control"
                :value="complaints"
                placeholder="Complaints"
                rows="2"
              ></textarea>
            </div> -->

            <div class="form-group col-md-4">
              <div class="form-check form-check-inline">
                <input
                  v-model="emergency"
                  class="form-check-input"
                  type="radio"
                  name="emergency"
                  value="0"
                  checked
                />
                <label class="form-check-label" for="normal">Normal</label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  v-model="emergency"
                  class="form-check-input"
                  type="radio"
                  name="emergency"
                  value="1"
                />
                <label class="form-check-label" for="emergency"
                  >Emergency</label
                >
              </div>
            </div>

            <div class="form-group col-md-4">
              <label for="paymentMode">Mode of Payment</label>
              <select
                @change="change_input"
                class="form-control"
                :class="{ 'is-invalid': errors.paymentMode }"
                name="paymentMode"
              >
                <option value="">Choose...</option>
                <option value="1">Cash</option>
                <option value="2">Invoice</option>
              </select>
              <div v-if="errors.paymentMode" class="text-danger small">
                {{ errors.paymentMode }}
              </div>
            </div>

            <div class="form-group col-md-4">
              <label for="department">Department to Send Patient To</label>
              <select
                @change="change_input"
                class="form-control"
                name="department"
              >
                <option disabled value="">Choose...</option>
                <option
                  :selected="department.id == 4"
                  v-for="department in departments"
                  :value="department.id"
                  :key="department.id"
                >
                  {{
                    department.department_name +
                    " - " +
                    department.department_description +
                    "(" +
                    department.department_code_id +
                    ")"
                  }}
                </option>
              </select>
            </div>

            <!-- Consultation Charges -->
            <div class="form-group col-md-4">
              <div class="form-check form-check-inline">
                <input
                  v-model="consultation_charge"
                  class="form-check-input"
                  type="radio"
                  name="charge_id"
                  value="1"
                  @change="handlechargeRadioChange"
                />
                <label class="form-check-label" for="applyCharge"
                  >Apply Consultation Charge</label
                >
              </div>
              <div class="form-check form-check-inline">
                <input
                  v-model="consultation_charge"
                  class="form-check-input"
                  type="radio"
                  name="charge_id"
                  value="0"
                  @change="handlechargeRadioChange"
                />
                <label class="form-check-label" for="noCharge">No Charge</label>
              </div>
            </div>

            <div v-if="consultation_charge == 1" class="form-group col-md-4">
              <label for="charge_id">Consultation Charge</label>
              <select
                @change="change_input"
                class="form-control"
                name="charge_id"
              >
                <option
                  v-for="consultation_charge in consultation_charges_arr"
                  :value="consultation_charge.id"
                  :key="consultation_charge.id"
                >
                  {{ consultation_charge.service_name }}
                </option>
              </select>
            </div>
          </div>

          <!-- Validation Summary -->
          <div v-if="Object.keys(errors).length > 0" class="alert alert-danger">
            <strong>Please fix the following errors:</strong>
            <ul class="mb-0">
              <li v-for="(error, field) in errors" :key="field">{{ error }}</li>
            </ul>
          </div>

          <button @click="submitHandler" class="btn btn-primary righter">
            Submit
          </button>
          <!--  -->
          <div
            style="
              height: 80px;
              background: linear-gradient(90deg, #4caf50, #8bc34a);
              margin-top: 25px 0;
              border-radius: 100% 0 0 0;
              position: relative;
              overflow: hidden;
            "
          >
            <div
              style="
                position: absolute;
                top: -50px;
                right: 0;
                width: 200px;
                height: 200px;
                background: rgba(255, 255, 255, 255);
                border-radius: 50%;
                transform: translateX(50%);
              "
            ></div>
          </div>
          <!--  -->
        </form>
        <div class="loader-style" v-if="loading">
          <span v-if="errDispaly == ''">Loading...</span>
          <span v-if="errDispaly != ''">{{ errDispaly }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { generalApiRequest } from "../../../api/apiIndex";
import PatientInput from "../../Patients/components/patient_input.vue";

export default {
  name: "ModalContent",
  data() {
    return {
      errDispaly: "",
      loading: false,
      patient_name: "",
      patient_id: "",
      age: "",
      dob: "",
      selecteddobOption: "dob",
      emergency: "0",
      dob_type: true,
      dob_age: "dob",
      gender: "",
      genders: [],
      clinics: [],
      clinic: 1,
      opd: "",
      phone: "",
      passport: "",
      residence: "",
      email: "",
      complaints: "",
      departments: [],
      department: 4,
      paymentModes: [],
      paymentMode: "",
      consultation_charge: "1",
      charge_id: null,
      consultation_charges_arr: [],

      // Next of kin fields
      next_of_kin_name: "",
      next_of_kin_relationship: "",
      next_of_kin_phone: "",
      next_of_kin_id: "",
      next_of_kin_address: "",
      next_of_kin_email: "",

      // Patient type
      patientType: "main",

      // Validation errors
      errors: {},

      // Track if patient data was pre-populated
      wasPrepopulated: false,
      originalPatientData: null,
    };
  },
  components: {
    PatientInput,
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },

    async submitHandler(event) {
      event.preventDefault();

      // Clear previous errors
      this.errors = {};

      // Validate form
      const isValid = this.validateForm();

      if (!isValid) {
        // Scroll to first error
        this.scrollToFirstError();
        return;
      }

      this.loading = true;
      const url = "create_visit";

      // Prepare patient data based on patient type
      const patientData = {
        name: this.patient_name,
        email: this.email,
        password: "1234",
        phone: this.phone,
        id_number: this.passport,
        dob: this.dob,
        location: this.residence,
        longitude: "",
        latitude: "",
        country: "Kenya",
        gender: this.gender,
        patientType: this.patientType,
        patient_id: this.patient_id,

        // Next of kin data
        next_of_kin: {
          name: this.next_of_kin_name,
          relationship: this.next_of_kin_relationship,
          phone: this.next_of_kin_phone,
          id_number: this.next_of_kin_id,
          address: this.next_of_kin_address,
          email: this.next_of_kin_email,
        },
      };

      // Set patient type
      patientData.patient_type = this.patientType;

      const body = {
        patient: patientData,
        visit_details: {
          clinic_id: this.clinic,
          payment_method: this.paymentMode,
          complaints: this.complaints,
          emergency: this.emergency,
          stage_code: this.department,
          consultation_charge: this.consultation_charge,
          charge_id: this.charge_id,
        },
      };

      try {
        const resp = await generalApiRequest(url, "POST", body, 1);
        if (resp.success) {
          this.loading = false;
          this.$emit("close");
          window.location.reload();
        } else if (!resp.success) {
          this.errDispaly = resp.message;
        }
      } catch (error) {
        this.errDispaly =
          "Unable to Start the Visit With The Data as Provided. Please counter-check and verify your data";
      }
    },

    validateForm() {
      let isValid = true;

      // Clear previous errors
      this.errors = {};

      // Main Patient Validation
      if (this.patientType === "main") {
        if (!this.patient_name || this.patient_name.trim() === "") {
          this.errors.patient_name = "Patient name is required";
          isValid = false;
        }

        // Validate either dob or age is provided
        if (!this.dob && !this.age) {
          this.errors.dob = "Either Date of Birth or Age is required";
          this.errors.age = "Either Date of Birth or Age is required";
          isValid = false;
        }

        if (!this.gender) {
          this.errors.gender = "Gender is required";
          isValid = false;
        }

        if (!this.passport || this.passport.trim() === "") {
          this.errors.passport = "ID/Passport number is required";
          isValid = false;
        }

        if (!this.paymentMode) {
          this.errors.paymentMode = "Mode of payment is required";
          isValid = false;
        }
      }

      // Dependent Patient Validation
      if (this.patientType === "dependent") {
        if (!this.patient_name || this.patient_name.trim() === "") {
          this.errors.patient_name = "Dependent name is required";
          isValid = false;
        }

        // Validate either dob or age is provided
        if (!this.dob && !this.age) {
          this.errors.dob = "Either Date of Birth or Age is required";
          this.errors.age = "Either Date of Birth or Age is required";
          isValid = false;
        }

        if (!this.gender) {
          this.errors.gender = "Gender is required";
          isValid = false;
        }

        if (!this.next_of_kin_name || this.next_of_kin_name.trim() === "") {
          this.errors.next_of_kin_name = "Next of kin name is required";
          isValid = false;
        }

        if (!this.next_of_kin_relationship) {
          this.errors.next_of_kin_relationship = "Relationship is required";
          isValid = false;
        }

        if (!this.paymentMode) {
          this.errors.paymentMode = "Mode of payment is required";
          isValid = false;
        }
      }

      // Email validation for both email fields (only if filled)
      if (this.email && this.email.trim() !== "") {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(this.email)) {
          this.errors.email = "Please enter a valid email address";
          isValid = false;
        }
      }

      if (this.next_of_kin_email && this.next_of_kin_email.trim() !== "") {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(this.next_of_kin_email)) {
          this.errors.next_of_kin_email = "Please enter a valid email address";
          isValid = false;
        }
      }

      return isValid;
    },

    validateEmailField(e) {
      const fieldName = e.target.name;
      const value = e.target.value;

      // Clear previous error for this field
      if (this.errors[fieldName]) {
        delete this.errors[fieldName];
      }

      // Only validate if email is provided
      if (value && value.trim() !== "") {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(value)) {
          this.errors[fieldName] = "Please enter a valid email address";
        }
      }
    },

    scrollToFirstError() {
      // Find first element with error class and scroll to it
      this.$nextTick(() => {
        const firstErrorElement = this.$el.querySelector(".is-invalid");
        if (firstErrorElement) {
          firstErrorElement.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        }
      });
    },

    hasOtherPropsBesidesName(obj) {
      if (!obj) return false;

      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key) && key !== "name") {
          return true;
        }
      }
      return false;
    },
    get_patient(option) {
      console.log(option);

      if (this.hasOtherPropsBesidesName(option)) {
        // Store original patient data for reference
        this.originalPatientData = {
          name: option.name,
          dob: option.dob,
          gender: option.gender,
          opd: option.opd,
          phone: option.phone,
          id_number: option.id_number,
          location: option.location,
          email: option.email,
          is_dependant: option.is_dependant,
          nok_name: option.nok_name,
          nok_phone: option.nok_phone,
          nok_id_number: option.nok_id_number,
          nok_address: option.nok_address,
          nok_email: option.nok_email,
          patient_id: option.id,
        };

        // Set the flag that patient data was pre-populated
        this.wasPrepopulated = true;

        // Populate the form with patient data
        this.patient_name = option.name;
        this.patient_id = option.id;
        this.dob = option.dob;
        this.dob_age = "dob";
        this.gender = option.gender;
        this.opd = option.opd;
        this.phone = option.phone;
        this.passport = option.id_number;
        this.residence = option.location;
        this.email = option.email;
        this.next_of_kin_relationship = option.nok_relationship || "";

        // Set patient type based on the patient's record
        this.patientType = option.is_dependant == 1 ? "dependent" : "main";

        // Auto-fill next of kin if patient has it in their record
        if (option.nok_id) {
          this.next_of_kin_name = option.nok_name || "";
          this.next_of_kin_relationship = option.nok_relationship || "";
          this.next_of_kin_phone = option.nok_phone || "";
          this.next_of_kin_id = option.nok_id_number || "";
          this.next_of_kin_address = option.nok_address || "";
          this.next_of_kin_email = option.nok_email || "";
        } else if (option.is_dependant == 1) {
          // If patient is dependent but no next of kin data, set default relationship
          this.next_of_kin_relationship = "parent";
        }
      } else {
        this.originalPatientData = {
          name: option.name,
        };
        this.patient_name = option.name;
      }
      // console.log(option);
    },

    change_input(e) {
      this[e.target.name] = e.target.value;

      // Clear error for this field when user changes it
      if (this.errors[e.target.name]) {
        delete this.errors[e.target.name];
      }

      if (e.target.name === "age" && this.selecteddobOption === "age") {
        this.dob = this.calculateDateOfBirth(e.target.value);
        // Clear dob error if age is provided
        if (this.errors.dob) delete this.errors.dob;
      } else if (e.target.name === "dob" && this.selecteddobOption === "dob") {
        this.age = this.calculateAge(new Date(e.target.value));
        // Clear age error if dob is provided
        if (this.errors.age) delete this.errors.age;
      }
    },

    calculateDateOfBirth(age) {
      if (isNaN(age) || age < 0) return null;
      const today = new Date();
      const birthYear = today.getFullYear() - age;
      const birthDate = new Date(birthYear, today.getMonth(), today.getDate());
      return birthDate.toISOString().slice(0, 10);
    },

    calculateAge(birthDate) {
      const today = new Date();
      let age = today.getFullYear() - birthDate.getFullYear();
      const monthDiff = today.getMonth() - birthDate.getMonth();
      if (
        monthDiff < 0 ||
        (monthDiff === 0 && today.getDate() < birthDate.getDate())
      ) {
        age--;
      }
      return age;
    },

    // Handle patient type change
    handlePatientTypeChange() {
      // Clear validation errors when changing patient type
      this.errors = {};

      if (this.patientType === "dependent") {
        // For dependent patients, set default next of kin relationship to "parent"
        this.next_of_kin_relationship = "parent";

        // If patient data was pre-populated from a main patient record,
        // transfer contact information to next of kin
        if (this.wasPrepopulated && this.originalPatientData) {
          // Only transfer if next of kin fields are empty (to avoid overwriting existing data)
          // DO NOT transfer patient name - keep next_of_kin_name empty or as is

          // Transfer contact info to next of kin
          if (!this.next_of_kin_phone) {
            this.next_of_kin_phone = this.originalPatientData.phone;
          }
          if (!this.next_of_kin_id) {
            this.next_of_kin_id = this.originalPatientData.id_number;
          }
          if (!this.next_of_kin_address) {
            this.next_of_kin_address = this.originalPatientData.location;
          }
          if (!this.next_of_kin_email) {
            this.next_of_kin_email = this.originalPatientData.email;
          }

          // Clear patient contact fields
          this.phone = "";
          this.passport = "";
          this.residence = "";
          this.email = "";
        } else {
          // For non-pre-populated cases, just clear the fields
          this.phone = "";
          this.passport = "";
          this.residence = "";
          this.email = "";
        }
      } else if (this.patientType === "main") {
        // If changing back to main patient type and we have original data
        if (this.wasPrepopulated && this.originalPatientData) {
          // Restore contact info if it was cleared
          if (!this.phone && this.originalPatientData.phone) {
            this.phone = this.originalPatientData.phone;
          }
          if (!this.passport && this.originalPatientData.id_number) {
            this.passport = this.originalPatientData.id_number;
          }
          if (!this.residence && this.originalPatientData.location) {
            this.residence = this.originalPatientData.location;
          }
          if (!this.email && this.originalPatientData.email) {
            this.email = this.originalPatientData.email;
          }

          // Clear next of kin contact info that was transferred
          if (this.next_of_kin_phone === this.originalPatientData.phone) {
            this.next_of_kin_phone = "";
          }
          if (this.next_of_kin_id === this.originalPatientData.id_number) {
            this.next_of_kin_id = "";
          }
          if (this.next_of_kin_address === this.originalPatientData.location) {
            this.next_of_kin_address = "";
          }
          if (this.next_of_kin_email === this.originalPatientData.email) {
            this.next_of_kin_email = "";
          }
        }
      }
    },

    handlechargeRadioChange() {
      if (this.consultation_charge == "0") {
        this.charge_id = null;
      }
    },

    async genders_get() {
      const res = await generalApiRequest("genders_get", "GET", {}, 1);
      this.genders = res;
    },

    async departments_get() {
      const res = await generalApiRequest("get_all_departments", "GET", {}, 1);
      this.departments = res;
    },

    async paymentModes_get() {
      const res = await generalApiRequest("get_payment_modes", "GET", {}, 1);
      this.paymentModes = res;
    },

    async charges_get() {
      const body = { billing_area: "1" };
      const res = await generalApiRequest(
        "get_consultation_charges",
        "GET",
        body,
        1,
      );
      this.consultation_charges_arr = res.data;
      this.charge_id = res.data[0]?.id || null;
    },

    async clinics_get() {
      const url = "get_all_clinics";
      const body = {};
      const res = await generalApiRequest(url, "GET", body, 1);
      this.clinics = res;
    },
  },
  mounted() {
    this.genders_get();
    this.departments_get();
    this.paymentModes_get();
    this.clinics_get();
    this.charges_get();
  },
};
</script>

<style scoped>
.modal-body {
  padding: 1rem;
  overflow-y: auto;
  flex-grow: 1;
}
.modal-footer {
  border-top: 1px solid #ddd;
  display: flex;
  justify-content: flex-end;
}
.patient-profile {
  margin: 0;
}
.close {
  background: rgb(233, 22, 22);
  border: 1px solid rgb(182, 178, 178);
  font-size: 1.5rem;
  color: white;
  line-height: 1;
  cursor: pointer;
}
.loader-style {
  display: flex;
  justify-content: center;
  font-weight: bold;
  color: black;
  font-size: 2em;
}

/* Style for section headers */
h6 {
  font-weight: bold;
  margin-bottom: 15px;
  padding-bottom: 5px;
}

.righter {
  float: right;
  margin-top: 20px;
  padding: 10px 30px;
  font-weight: bold;
}

/* Card-like styling for sections */
.card-section {
  border: 2px solid;
  border-radius: 5px;
  padding: 20px;
  margin-bottom: 20px;
}

/* Validation styles */
.is-invalid {
  border-color: #dc3545 !important;
}

.text-danger {
  color: #dc3545 !important;
  font-size: 0.875em;
  margin-top: 0.25rem;
}

.alert-danger {
  margin-top: 20px;
  margin-bottom: 20px;
}
</style>
